// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Portrait {
  display: inline-flex;
}
/*# sourceMappingURL=Portrait.css.map */`, "",{"version":3,"sources":["webpack://./Portrait.less","webpack://./wp_components/Portrait/Portrait.less"],"names":[],"mappings":"AAAA;EACI,oBAAA;ACCJ;AACA,uCAAuC","sourcesContent":[".Portrait {\n    display: inline-flex;\n}",".Portrait {\n  display: inline-flex;\n}\n/*# sourceMappingURL=Portrait.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
